<script setup lang="ts">
import {QBtn, useDialogPluginComponent} from 'quasar'
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import Translator from "@/utils/common/Translator.ts";
import OutputFormat from "@/utils/constants/OutputFormat.ts";
import BusinessFunction from "@/utils/constants/BusinessFunction.ts";
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import DOCXIcon from "@/assets/editViewIcons/DOCXIcon.vue";
import XLSXIcon from "@/assets/editViewIcons/XLSXIcon.vue";
import PPTXIcon from "@/assets/editViewIcons/PPTXIcon.vue";
import SendEmailIcon from "@/assets/editViewIcons/SendEmailIcon.vue";
import PDFIcon from "@/assets/editViewIcons/PDFIcon.vue";

let props = defineProps({
  title: {
    type: String,
    required: true
  }
});
const {compactMode} = storeToRefs(useNamaFlagsStore());

const printAsBusinessFunctions = [
  {
    businessFunction: BusinessFunction.exportAsPDF,
    format: OutputFormat.PDF,
    icon: PDFIcon
  },
  {
    businessFunction: BusinessFunction.exportAsDOCX,
    format: OutputFormat.DOCX,
    icon: DOCXIcon
  },
  {
    businessFunction: BusinessFunction.exportAsXLSX,
    format: OutputFormat.XLSX,
    icon: XLSXIcon
  },
  {
    businessFunction: BusinessFunction.exportAsPPTX,
    format: OutputFormat.PPTX,
    icon: PPTXIcon
  },
  {
    businessFunction: BusinessFunction.sendEmailWithResult,
    format: BusinessFunction.sendEmailWithResult,
    icon: SendEmailIcon
  },
]

defineEmits([
  // REQUIRED; need to specify some events that your
  // component will emit through useDialogPluginComponent()
  ...useDialogPluginComponent.emits
])

const {dialogRef, onDialogHide, onDialogOK, onDialogCancel} = useDialogPluginComponent()

function onOKClick(format: string) {
  onDialogOK(format);
}

function onCancelClick() {
  onDialogCancel();
}
</script>

<template>

  <q-dialog ref="dialogRef" @hide="onDialogHide">
    <q-card class="tw-shadow-none dark:tw-text-white dark:tw-bg-namaBackground-deep-dark tw-rounded-2xl tw-bg-namaBackground-deep-light tw-w-fit">
      <q-bar v-if="title" class="tw-text-xs tw-text-namaFontColor-input-light tw-bg-[#CED4DA] dark:tw-bg-[#212529] dark:tw-text-white tw-h-10">
        <div>{{ Translator.translateId('exportAs') }}</div>
        <q-space/>
        <q-avatar square @click="onDialogCancel" class="tw-w-5 nama-avatar-hover tw-cursor-pointer">
          <DialogCloseIcon/>
        </q-avatar>
      </q-bar>
      <div class="tw-p-8 tw-place-self-center">
        <q-card-section class="tw-flex tw-flex-wrap tw-justify-center tw-gap-9 mobile:tw-gap-5">
          <template v-for="(action, index) in printAsBusinessFunctions" :key="action.businessFunction">
            <div class="tw-flex tw-flex-col tw-items-center">
              <q-btn
                unelevated
                :title="Translator.translateId(action.businessFunction)"
                @click="onOKClick(action.format)"
                :dense="compactMode"
                class="tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-rounded-md tw-p-1">
                <component :is="action.icon" class="tw-h-14 mobile:tw-h-9"/>
              </q-btn>
              <div class="tw-text-namaFontColor-input-light dark:tw-text-white mobile:tw-hidden">{{ Translator.translateId(action.businessFunction) }}</div>
              <div class="tw-text-namaFontColor-input-light dark:tw-text-white desktop:tw-hidden">{{ Translator.translateId(action.format) }}</div>
            </div>
          </template>
        </q-card-section>
      </div>
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
